
const searchToggle = document.querySelector('[header-search-toggle]');
const searchForm = document.querySelector('#SearchForm');
const searchInput = document.querySelector('[header-search-form-input]');
const searchCloseBtn = document.querySelector('[header-search-close-btn]');
const backdrop = document.querySelector('[backdrop]');
const headerWrap = document.querySelector('[header-wrap]');

if (searchToggle && searchForm) {
  function openSearch() {
    searchToggle.setAttribute('aria-expanded', 'true');
    searchForm.setAttribute('aria-expanded', 'true');
    if (headerWrap && headerWrap.parentNode) {
      headerWrap.parentNode.classList.add('header--search-active');
    }
    if (backdrop) backdrop.classList.add('backdrop--active');
    if (searchInput) {
      setTimeout(function() {
        searchInput.focus();
      }, 150);
    }
  }

  function closeSearch() {
    searchToggle.setAttribute('aria-expanded', 'false');
    searchForm.setAttribute('aria-expanded', 'false');
    if (headerWrap && headerWrap.parentNode) {
      headerWrap.parentNode.classList.remove('header--search-active');
    }
    if (backdrop) backdrop.classList.remove('backdrop--active');
  }

  function isSearchOpen() {
    return searchToggle.getAttribute('aria-expanded') === 'true';
  }

  // Use capture phase to run before main.js handlers
  searchToggle.addEventListener('click', function(e) {
    // Don't interfere on search page
    if (window.location.pathname.includes('/search')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    if (isSearchOpen()) {
      closeSearch();
    } else {
      openSearch();
    }
  }, true);

  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeSearch();
    }, true);
  }

  // Close search on backdrop click
  if (backdrop) {
    backdrop.addEventListener('click', function() {
      if (isSearchOpen()) {
        closeSearch();
      }
    });
  }

  // Close search on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isSearchOpen()) {
      closeSearch();
    }
  });
} else {
  console.warn('Search elements not found');
}
